module.exports = __webpack_public_path__ + "img/home_bg_1.e014a964.png";